// DA → EN slug mapping used to translate URL slugs on /en/ routes.
// Mirrors /app/backend/data/slug_map.py — keep them in sync.

const SERVICE = {
  "teknisk-seo": "technical-seo",
  "off-page-seo-linkbuilding": "off-page-seo-link-building",
  "lokal-seo": "local-seo",
  "seo-strategi": "seo-strategy",
  "seo-migreringer": "seo-migrations",
  "kursus": "course",
};
const POST = {
  "interne-links": "internal-links",
  "teknisk-seo-checkliste": "technical-seo-checklist",
  "seo-strategi-begyndere": "seo-strategy-beginners",
  "ai-soegning-geo": "ai-search-geo",
  "hvor-mange-backlinks-skal-man-bruge": "how-many-backlinks-do-you-need",
  "backlinks-i-google-search-console": "backlinks-in-google-search-console",
  "seo-ordbog": "seo-glossary",
};
const STACK = { "some": "social" };
const PROJECT = {};
const TOOL = {};

const TABLES = { service: SERVICE, post: POST, stack: STACK, project: PROJECT, tool: TOOL };

/** Return the localised slug for a given canonical (DA) slug + lang. */
export function toLangSlug(kind, daSlug, lang) {
  if (lang !== "en" || !daSlug) return daSlug;
  const t = TABLES[kind] || {};
  return t[daSlug] || daSlug;
}

/** Resolve any slug (DA or EN) back to the canonical DA slug used for lookup. */
export function toDaSlug(kind, slug) {
  if (!slug) return slug;
  const t = TABLES[kind] || {};
  const reverse = Object.fromEntries(Object.entries(t).map(([d, e]) => [e, d]));
  return reverse[slug] || slug;
}

/** Full list of DA→EN slug pairs (used by prerender to emit redirect stubs). */
export function slugPairs(kind) {
  return Object.entries(TABLES[kind] || {}).map(([da, en]) => ({ da, en }));
}

export const SLUG_MAPS = TABLES;
